import React, { useState } from 'react';
import Axios from 'axios';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { KakaoLinkDefault } from 'react-kakao-link';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
import cookieCutter from 'cookie-cutter';

// <핫이슈 박스 에서 공유부분 컴포넌트>
export default function Box(props) {
  const type = props.data.type;
  const [current, setCurrent] = useState(false); // 이미지 및 페이징 부분 위치제어
  const [currentToast_alert, setCurrentToast_alert] = useState(false); // Toast 팝업 상태값 제어
  const [currentSubscribe_alert, setCurrentSubscribe_alert] = useState(false); //  구독 팝업 상태값 제어
  const [currentLogin_alert, setCurrentLogin_alert] = useState(false); //  로그인 팝업 상태값 제어
  const [currentSubscribenone_alert, setCurrentSubscribenone_alert] = useState(false); //  구독 팝업 상태값 제어
  const [subscribeTitle, setSubscribeTitle] = useState('');
  const [nonSubscribeTitle, setNonSubscribeTitle] = useState('');
  //프로그램 구독이 안되는 콘텐츠입니다.

  const [bookMarkState, setBookMarkState] = useState(props.data.bookMarkState);
  const subscribeState = props.data.subscribeState;
  const subscribeCountCheck = props.data.subscribeCountCheck;

  const likeCnt = props.data.like_cnt; // 좋아요 갯수
  const linkUrl = getClickLinkParams(props.data.link_url, 'ref=sbshotissue');
  
  const title = props.data.title; // 타이틀
  const imgUrl = props.data.img_url; // 이미지 주소 url
  let kakaoThumnailImage = '';
  const [eventMSG, setEventMSG] = useState(''); //좋아요 및 url 복사할때 나오는 팝업

  function loginCheckPopClose() {
    setCurrentLogin_alert(false);
  }

  function loginCheckPopConfirm() {
    setCurrentLogin_alert(true);
    window.location.href = "https://join.sbs.co.kr/login/login.do?returnUrl=" + encodeURIComponent(window.location.href);
  }

  try {
    if (imgUrl != null) {
      if (type === '5') {
        if (props.data.content_img_url != null)
          kakaoThumnailImage = props.data.content_img_url;
      } else {
        kakaoThumnailImage = imgUrl[0];
      }
    }
  } catch (error) {
    console.error(error);
  }

  const state = {
    value: '',
    copied: false
  };

  function onOpenClick() {
    setCurrent(true);
  }

  function onCloseClick() {
    setCurrent(false);
  }


  function onSubscribeClick() {

    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분(로그아웃이 헤더에서 사용되므로 액션 마다 체크해주자)
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');

    //로그인 이벤트 체크 처리
    if (LOGIN_JWT == null) {
      setCurrentSubscribe_alert(false);
      if (currentSubscribenone_alert == true) {
        setCurrentLogin_alert(false);
      } else {
        setCurrentLogin_alert(true);
      }
      return;
    }

    //type2 일때 구독이 되면 안됨 
    if (type != null) {
      if (type == 2) {
        if (currentSubscribenone_alert == false) {
          setNonSubscribeTitle('프로그램 구독이 안되는 콘텐츠입니다.');
          setCurrentSubscribenone_alert(true);
        } else {
          setCurrentSubscribenone_alert(false);
        }
        return;
      }
    }

    // 프로그램 아이디가 없을시 구독안됨
    if (props.data.programid == null || props.data.programid == '' || props.data.programid == 'undefined') {
      if (currentSubscribenone_alert == false) {
        setNonSubscribeTitle('프로그램 구독이 안되는 콘텐츠입니다.');
        setCurrentSubscribenone_alert(true);
      } else {
        setCurrentSubscribenone_alert(false);
      }
      return;
    }

    // 구독 카운트가 10개로 갯수제약있음  
    if (props.data.subscribeState != true) {
      if (subscribeCountCheck != null) {
        if (subscribeCountCheck > 9) {
          if (currentSubscribenone_alert == false) {
            setNonSubscribeTitle('프로그램 최대 구독 개수는 10개입니다.');
            setCurrentSubscribenone_alert(true);
          } else {
            setCurrentSubscribenone_alert(false);
          }
          return;
        }
      }
    }

    let title;
    let url = 'https://apis.sbs.co.kr/allvod-api/get_pgm_title?pgm_id=' + props.data.programid;
    Axios.get(url).then(function (response) {
      if (response.data !== null) {
        title = response.data.title;
      }
    }).catch(function (error) {
      console.error(error);
    }).finally(() => {
      if (title != null) {
        if (props.data.subscribeState == true) {// 구독이 활성화 되어있음
          setSubscribeTitle(title + ' 구독을 취소하시겠습니까?');
        } else { // 구독이 비활성화 되어있음
          setSubscribeTitle(title + ' 구독을 하시겠습니까?\n * 내구독 탭에서 ' + title + ' 콘텐츠만 모아서 즐기세요!');
        }

        if (currentSubscribe_alert == true) {
          setCurrentSubscribe_alert(false);
        } else {
          setCurrentSubscribe_alert(true);
        }
      } else {
        if (currentSubscribenone_alert == true) {
          setCurrentSubscribenone_alert(false);
        } else {
          setCurrentSubscribenone_alert(true);
        }
      }
    });

  }

  // TODO childmild 공유하기 url 남음
  // https://www.facebook.com/sharer/sharer.php?u=PAGE_URL
  // 페이스북 공유하기
  const faceBookShare = () => {
    // //console.log('find data share faceBook');
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + linkUrl);
  };

  // 트위터 공유하기
  const twitterShare = () => {
    // //console.log('find data share twitter');
    window.open('https://twitter.com/intent/tweet?url=' + linkUrl);
  };

  const template = {
    objectType: 'feed',
    content: {
      title: title,
      description: title,
      imageUrl: kakaoThumnailImage,
      link: {
        mobileWebUrl: linkUrl,
        webUrl: linkUrl
      }
    }
  };

  // 일반주소 공유하기
  const urlShare = () => {
    // 로직 만들어야함 신규 리소스 적용된 버전으로
    // alert('URL이 복사되었습니다.');
    setCurrentToast_alert(true);
    setEventMSG('URL이 복사되었습니다.');

    setTimeout(function () {
      setCurrentToast_alert(false);
      setEventMSG('');
    }, 1700);
  };

  //구독
  const subscribe = () => {

    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분(로그아웃이 헤더에서 사용되므로 액션 마다 체크해주자)
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');
    if (LOGIN_JWT == null) {
      setCurrentSubscribe_alert(false);
      if (currentSubscribenone_alert == true) {
        setCurrentLogin_alert(false);
      } else {
        setCurrentLogin_alert(true);
      }
      return;
    }

    let url = "";
    let bodyData;
    if (props.data.subscribeState == true) {
      //구독 취소
      url = "https://apis.sbs.co.kr/allvod-api/subscription_pgm_off";
      bodyData = props.data;
      //TODO childmild _id찾기 체크(all페이지와, 찜차이때문)
      if ((props.data.pgm_id != null && props.data.pgm_id != '') || (props.data.programid != null && props.data.programid != '')) {
        bodyData = props.data;
      } else {
        alert('구독 취소 하실수 없습니다.');
        return;
      }

    } else {
      //구독
      url = "https://apis.sbs.co.kr/allvod-api/subscription_pgm";
      bodyData = props.data;
      if ((props.data.pgm_id != null && props.data.pgm_id != '') || (props.data.programid != null && props.data.programid != '')) {
        url = "https://apis.sbs.co.kr/allvod-api/subscription_pgm";
        bodyData = props.data;
      } else {
        alert('구독 하실수 없습니다.');
        return;
      }
    }

    const config = {
      headers: {
        'jwt-token': LOGIN_JWT,
        'platform': platformCookie,
      }
    };

    // let bodyData = props.data; //api 에서 삭제일때는 id만 바라보고, 찜을할때는 풀데이터를 쌓는구조이므로 걍 다쏘자
    Axios.post(url, bodyData, config).then(function (response) {
      if (response.data.message !== null) {
        if (props.data.subscribeState != true) {//취소일때는 아님
          window.location.href = '/hotissue/subscribe';
        } else {
          //TODO // 현재창 리플레쉬
          window.location.reload();
        }
      }
    }).catch(function (error) {
      console.error(error);
    }).finally(() => {
      // setEventCheck(false);
    });

  };

  //찜
  const [bookMarkingState, setBookMarkingState] = useState(false); //통신문 시작 체크 구문 중복 체크 방지용
  const bookmark = () => {

    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분(로그아웃이 헤더에서 사용되므로 액션 마다 체크해주자)
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');
    if (LOGIN_JWT == null) {
      setCurrentSubscribe_alert(false);
      if (currentSubscribenone_alert == true) {
        setCurrentLogin_alert(false);
      } else {
        setCurrentLogin_alert(true);
      }
      return;
    }

    let url = "";
    let bodyData;

    // //console.log('find data childmild ===>> ' + props.data.bookMarkState);
    if (bookMarkState == true) {
      //찜취소
      url = "https://apis.sbs.co.kr/allvod-api/subscription_off";
      //TODO childmild _id찾기 체크(all페이지와, 찜차이때문)
      if (props.data._id == null) {
        bodyData = props.data.bookMarkid;
      } else {
        bodyData = props.data;
      }

    } else {
      //찜
      url = "https://apis.sbs.co.kr/allvod-api/subscription";
      bodyData = props.data;
    }

    const config = {
      headers: {
        'jwt-token': LOGIN_JWT,
        'platform': platformCookie,
      }
    };

    // let bodyData = props.data; //api 에서 삭제일때는 id만 바라보고, 찜을할때는 풀데이터를 쌓는구조이므로 걍 다쏘자
    setBookMarkingState(true);
    Axios.post(url, bodyData, config).then(function (response) {
      if (response.data.message !== null) {
        // alert(response.data.reuslt);
        // window.location.reload();
      }
    }).catch(function (error) {
      console.error(error);
      setBookMarkingState(false);
      // setEventMSG('콘텐츠가 찜 목록에 실패하였습니다.');
    }).finally(() => {
      if (bookMarkState == true) {
        //찜 버튼처리 설정 부분
        setBookMarkState(false);
        //찜 Toast 창 처리 부분
        setCurrentToast_alert(true);
        setEventMSG('콘텐츠가 찜 목록에 삭제되었습니다.');
        setTimeout(function () {
          setCurrentToast_alert(false);
          setEventMSG('');
          setBookMarkingState(false);
        }, 1700);
      } else {
        //찜
        setBookMarkState(true);
        //찜 Toast 창 처리 부분
        setCurrentToast_alert(true);
        setEventMSG('콘텐츠가 찜 목록에 추가되었습니다.');
        setTimeout(function () {
          setCurrentToast_alert(false);
          setEventMSG('');
          setBookMarkingState(false);
        }, 1700);
      }
      const refreshCheck = props.data.bookMarkReFresh;
      if (refreshCheck == true) {
        //TODO childmild ==>> 해당 부분에서 찜화면에서 넘겨받으면 통신 완료후 리플레쉬 때리자
        window.location.href = '/hotissue/bookmark';
      }

    });//finish finally()

  };

  return (
    <>
      <div className='hmb_function_w' onMouseLeave={onCloseClick}>
        <div className={`live_btn_subscribe ${subscribeState === true ? 'current' : ''}`}>
          <button type="button" className="live_link_cont" title="구독하기" onClick={onSubscribeClick}>
            <span className="live_btn_icon btn_icon_subscribe"><i className="ir">구독</i></span>
          </button>
        </div>
        <div className={`live_btn_bookmark ${bookMarkState === true ? 'current' : ''}`}>
          <button type="button" className="live_link_cont" title="찜하기" onClick={bookmark}>
            <span className="live_btn_icon btn_icon_bookmark"><i className="ir">찜</i></span>
          </button>
        </div>
        <div className={`live_btn_share ${current === true ? 'current' : ''}`}>
          <button type='button' className='live_link_cont' title='공유하기 레이어 열기' onClick={onOpenClick}>
            <span className='live_btn_icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='30.002' height='26' viewBox='0 0 30.002 26'><g transform='translate(-637.546 -498.729)'><path d='M662.655,512.874h0a1.021,1.021,0,0,0-1.024,1.018h0v8.8H639.6V507.214h6.157a1.02,1.02,0,1,0,.064-2.039h-7.247a1.023,1.023,0,0,0-1.025,1.019h0v17.514a1.022,1.022,0,0,0,1.024,1.02h24.084a1.02,1.02,0,0,0,1.024-1.018v-9.818A1.021,1.021,0,0,0,662.655,512.874Z' /><path d='M667.405,503.958v0l-4.879-5.079a.467.467,0,0,0-.566-.09.52.52,0,0,0-.253.54l.435,2.634c-2.613.2-13.365,1.8-15.522,14.148a.512.512,0,0,0,.341.581.45.45,0,0,0,.136.021.484.484,0,0,0,.449-.316,15.821,15.821,0,0,1,15.231-10.351l-1.051,3.186a.525.525,0,0,0,.2.6.467.467,0,0,0,.6-.068l4.879-5.079A.53.53,0,0,0,667.405,503.958Z' /></g></svg>
              <i className='hide'>공유하기</i>
            </span>
          </button>
          <div className='layer_share_list'>
            <button onClick={faceBookShare} className='layer_share_link' title='페이스북에 공유 새창 열림'>
              <span className='icon_share_facebook'>
                <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'><g transform='translate(-292.917 -400.958)'><rect width='36' height='36' transform='translate(292.917 400.958)' /><path d='M314.09,412.995h1.327v-2.589a16.139,16.139,0,0,0-2.355-.206c-2.4,0-3.974,1.457-3.974,4.093v2.318h-2.671v3.041h2.671v8.064h3.288v-8.064h2.451l.466-3.041h-2.917v-1.973A1.52,1.52,0,0,1,314.09,412.995Z' /></g></svg>
              </span>
            </button>
            <button onClick={twitterShare} className='layer_share_link' title='트위터에 공유 새창 열림'>
              <span className='icon_share_twitter'>
                <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'><g transform='translate(-338.278 -401)'><rect width='36' height='36' transform='translate(338.278 401)' /><path d='M353.647,427.327a10.436,10.436,0,0,0,10.508-10.507c0-.16,0-.32-.011-.478a7.529,7.529,0,0,0,1.843-1.912,7.362,7.362,0,0,1-2.121.581,3.7,3.7,0,0,0,1.624-2.043,7.391,7.391,0,0,1-2.345.9,3.7,3.7,0,0,0-6.294,3.368,10.484,10.484,0,0,1-7.612-3.859,3.7,3.7,0,0,0,1.144,4.931,3.683,3.683,0,0,1-1.673-.462c0,.015,0,.03,0,.047a3.694,3.694,0,0,0,2.963,3.62,3.681,3.681,0,0,1-.974.13,3.613,3.613,0,0,1-.694-.067,3.7,3.7,0,0,0,3.45,2.565,7.407,7.407,0,0,1-4.587,1.581,7.522,7.522,0,0,1-.88-.051,10.448,10.448,0,0,0,5.66,1.659' /></g></svg>
              </span>
            </button>

            <KakaoLinkDefault
              className='layer_share_link'
              template={template}
              jsKey='46405579eeb321d6f8449737c83be6d9'
            >
              <button>
                <a className='layer_share_link' title='카카오톡에 공유 새창 열림'>
                  <span className='icon_share_kakao'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'><g transform='translate(-383.639 -401)'><rect width='36' height='36' transform='translate(383.639 401)' /><path d='M115.759,57.6c-4.97,0-9,3.446-9,7.7a7.522,7.522,0,0,0,4.176,6.5l-.849,3.428a.3.3,0,0,0,.064.292.236.236,0,0,0,.341.017l3.646-2.667a10.546,10.546,0,0,0,1.621.128c4.969,0,9-3.446,9-7.7s-4.031-7.7-9-7.7' transform='translate(285.879 352.398)' /></g></svg>
                  </span>
                </a>
              </button>
            </KakaoLinkDefault>

            <button onClick={urlShare} className='layer_share_link' title='url로 공유하기'>
              <CopyToClipboard
                text={linkUrl}
                onCopy={() => urlShare}
              >
                <span className='icon_share_url'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36'><g transform='translate(-429 -401)'><rect width='36' height='36' transform='translate(429 401)' /><g><path d='M635.852,564.211q-.027,1.9-1.835,1.9a1.876,1.876,0,0,1-1.353-.468,1.988,1.988,0,0,1-.489-1.49v-6.862h-2.143v6.927a3.447,3.447,0,0,0,1.093,2.648,4.151,4.151,0,0,0,2.892.965,4.109,4.109,0,0,0,2.917-.993,3.5,3.5,0,0,0,1.068-2.7v-6.849l-2.15,0Z' transform='translate(-196.03 -143.277)' /><path d='M647,562.2a3.181,3.181,0,0,0,.461-1.774,2.833,2.833,0,0,0-1-2.32,4.356,4.356,0,0,0-2.842-.822h-3.863v10.4H641.9v-3.8h1.707l1.945,3.8h2.3v-.1l-2.25-4.248A3.139,3.139,0,0,0,647,562.2Zm-2.124-.468a1.771,1.771,0,0,1-1.25.411H641.9v-3.12h1.721a1.737,1.737,0,0,1,1.281.42,1.57,1.57,0,0,1,.418,1.157A1.468,1.468,0,0,1,644.879,561.734Z' transform='translate(-196.03 -143.277)' /><path d='M651.234,565.966v-8.68h-2.142v10.4h6.691v-1.72Z' transform='translate(-196.03 -143.277)' /></g></g></svg>
                </span>
              </CopyToClipboard>
            </button>
            <button className='layer_share_close' title='공유 레이어 닫기' onClick={onCloseClick}>
              <span className='icon_share_close'>
                <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'><g transform='translate(-164.018 -178.02)'><g transform='translate(164.018 178.02)'><path d='M12.17,1.271.521,1.434A.572.572,0,0,1,0,.806H0A.612.612,0,0,1,.538.163L12.188,0a.572.572,0,0,1,.521.628h0A.612.612,0,0,1,12.17,1.271Z' transform='translate(1.014 0) rotate(45)' /><path d='M12.17.163.521,0A.572.572,0,0,0,0,.628H0a.612.612,0,0,0,.538.643l11.649.163a.572.572,0,0,0,.521-.628h0A.612.612,0,0,0,12.17.163Z' transform='translate(10 1.014) rotate(135)' /></g></g></svg>
                <i className='hide'>닫기</i>
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* 좋아요 및 복사시에 시스템 팝업 대신 띄우기로한 디자인 팝업 및 toast 처리 팝업 */}
      <div className={`hmb_alert_w ${currentToast_alert === true ? 'current_alert' : ''}`} role="alert">
        <span className="hmb_alert_text">{eventMSG}</span>
      </div>

      {/* 구독 팝업 */}
      <div className={`hmb_alert_w ${currentSubscribe_alert === true ? 'current_alert' : ''}`} role="alert">
        <span className="hmb_alert_title">{subscribeTitle}</span>
        <div className="hmb_alert_link_w">
          <a onClick={onSubscribeClick} href="#none" className="hmb_alert_link">취소</a>
          <a onClick={subscribe} href="#none" className="hmb_alert_link">확인</a>
        </div>
      </div>

      {/* 구독 이 안되는 팝업 */}
      <div className={`hmb_alert_w ${currentSubscribenone_alert === true ? 'current_alert' : ''}`} role="alert">
        <span className="hmb_alert_title">{nonSubscribeTitle}</span>
        <div className="hmb_alert_link_w">
          <a onClick={onSubscribeClick} href="#none" className="hmb_alert_link">확인</a>
        </div>
      </div>

      {/* 로그인 체크팝업 */}
      <div className={`hmb_alert_w ${currentLogin_alert === true ? 'current_alert' : ''}`} role="alert">
        <span className="hmb_alert_title">로그인 후 이용이 가능합니다. 로그인 하시겠습니까?</span>
        <div className="hmb_alert_link_w">
          <a onClick={loginCheckPopClose} href="#none" className="hmb_alert_link">취소</a>
          <a onClick={loginCheckPopConfirm} href="#none" className="hmb_alert_link">확인</a>
        </div>
      </div>

    </>
  );
}// Finish default function Box()
